import { React, Component, classNames } from '@digsup/core-ui';
import PropTypes from 'prop-types';
import { Icon } from '@digsup/components-icon';

import { Input } from './Input';
import { styles } from './Input.scss';

const cx = classNames.bind(styles);

class PasswordComponent extends Component {
  state = {
    visible: false,
  };

  toggleVisibility = () => {
    const { disabled } = this.props;
    if (disabled) {
      return;
    }

    this.setState(({ visible }) => ({ visible: !visible }));
  };

  getIcon() {
    const suffixIconClasses = cx('c-input-affix__icon c-input-affix__btn-icon');
    const iconProps = {
      className: suffixIconClasses,
      onClick: this.toggleVisibility,
      key: 'passwordIcon',
      role: 'button',
      tabIndex: 0,
      onKeyDown: e => e.keyCode === 13 && this.toggleVisibility(),
      onMouseDown: e => {
        // Prevent focused state lost
        // https://github.com/ant-design/ant-design/issues/15173
        e.preventDefault();
      },
    };
    const iconName = this.state.visible ? 'eye-view' : 'eye-hidden';
    return (
      <i {...iconProps}>
        <Icon name={iconName} size={this.props.size} />
      </i>
    );
  }

  render() {
    const { visibilityToggle, className, forwarderRef, ...props } = this.props;
    const { visible } = this.state;

    const suffixNode = visibilityToggle && this.getIcon();

    return (
      <Input
        ref={forwarderRef}
        type={visible ? 'text' : 'password'}
        suffix={suffixNode}
        className={`c-input--password ${className || ''}`}
        {...props}
      />
    );
  }
}

export const Password = React.forwardRef((props, ref) => (
  <PasswordComponent {...props} forwarderRef={ref} />
));

Password.propTypes = {
  disabled: PropTypes.bool,
  /**
   * Whether show toggle button
   */
  visibilityToggle: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
};

Password.defaultProps = {
  disabled: false,
  visibilityToggle: true,
  size: 'medium',
};
